var installedModules = {};
var moduleToHandlerMapping = {
	7386: {
		getter: () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	8934: {
		getter: () => (__webpack_require__.e(342).then(() => (() => (__webpack_require__(961))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	8025: {
		getter: () => (Promise.all([__webpack_require__.e(985), __webpack_require__.e(19)]).then(() => (() => (__webpack_require__(3985))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.85.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-query-persist-client",
	},
	3516: {
		getter: () => (Promise.all([__webpack_require__.e(443), __webpack_require__.e(237)]).then(() => (() => (__webpack_require__(3443))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.1.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "mobx-react-lite",
	},
	6207: {
		getter: () => (Promise.all([__webpack_require__.e(507), __webpack_require__.e(237)]).then(() => (() => (__webpack_require__(507))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@pflm-shared",
	},
	9525: {
		getter: () => (__webpack_require__.e(996).then(() => (() => (__webpack_require__(3996))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.8.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	9237: {
		getter: () => (__webpack_require__.e(813).then(() => (() => (__webpack_require__(7813))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "6.13.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "mobx",
	},
	9019: {
		getter: () => (__webpack_require__.e(946).then(() => (() => (__webpack_require__(3946))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.85.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-query",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"19": [
		9019
	],
	"25": [
		8025
	],
	"237": [
		9237
	],
	"386": [
		7386
	],
	"934": [
		8934
	],
	"992": [
		3516,
		6207,
		9525
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}